import React from "react";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Box,
  IconButton,
} from "@mui/material";
import { User, Edit } from "iconsax-react";

const TableComponent = ({
  column,
  data,
  label,
  totalGuest,
  handleEditTable = () => {},
}) => {
  return (
    <Box
      sx={{
        marginTop: "30px",
        border: "1px solid #EAECF0",
        padding: "24px",
        boxShadow:
          " 0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)",
        borderRadius: "8px",
      }}>
      <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
        <Typography
          sx={{ color: "#101828", fontWeight: 600, fontSize: "18px" }}>
          {label}
        </Typography>
        <Box
          sx={{
            borderRadius: "16px",
            padding: "2px 8px",
            background: "#EFFCF9",
            width: "70px",
            textAlign: "center",
          }}>
          <Typography
            sx={{
              color: "#337D96",
              fontWeight: "500",
              fontSize: "12px",
            }}>
            {`${totalGuest} guests`}
            {/* {`${soDetail?.guestList?.length} guests`} */}
          </Typography>
        </Box>
      </Box>
      <Table sx={{ marginTop: "20px", border: "1px solid #EAECF0" }}>
        <TableHead sx={{ background: "#F9FAFB" }}>
          <TableRow
            sx={{
              ".MuiTableCell-root.MuiTableCell-head": {
                fontSize: "12px",
                color: "#475467",
                fontWeight: 400,
              },
            }}>
            {column.map(({ label, value }, index) => {
              return <TableCell>{label}</TableCell>;
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, indexTable) => {
            return (
              <TableRow key={indexTable}>
                {column.map(({ label, value, type = "text" }, index) => {
                  return (
                    <>
                      {type === "textWithIcon" ? (
                        <>
                          <TableCell key={index}>
                            <Box sx={{ display: "flex", flexDirection: "row" }}>
                              <User
                                size="18px"
                                color="#4AA1B3"
                                style={{ marginRight: "10px" }}
                              />
                              <Typography
                                sx={{
                                  display: "flex",
                                  alignItems: "flex-end",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  color: "#475467",
                                }}>
                                {item[value]}
                              </Typography>
                            </Box>
                          </TableCell>
                        </>
                      ) : type === "badge" ? (
                        <TableCell key={index}>
                          <Box
                            sx={{
                              fontSize: "14px",
                              fontWeight: 400,
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              borderRadius: "16px",
                              background:
                                item[value].includes("Male") ||
                                item[value].includes("Ocean Bungalow")
                                  ? "#C7CBF8"
                                  : item[value].includes(
                                      "Pelagian Full Boat Charter"
                                    )
                                  ? "#EEFBD8"
                                  : item[value].includes("Villa")
                                  ? "#FFF1CC"
                                  : "#E2FCF6",
                              color: item[value].includes("Female")
                                ? "#00034C"
                                : "#205B79",
                              width: "auto",
                              maxWidth: "188px",
                              height: "24px",
                            }}>
                            {item[value]}
                          </Box>
                        </TableCell>
                      ) : value === "action" ? (
                        <TableCell>
                          <IconButton onClick={handleEditTable}>
                            <Box
                              sx={{
                                padding: "6px",
                                background: "#FFFFFF",
                                border: " 1px solid #D0D5DD",
                                boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                                borderRadius: "8px",
                                width: "36px",
                                height: "36px",
                              }}>
                              <Edit />
                            </Box>
                          </IconButton>
                        </TableCell>
                      ) : (
                        <TableCell key={index}>
                          <Typography
                            sx={{
                              fontWeight: 300,
                              fontSize: "14px",
                              color: "#475467",
                            }}>
                            {item[value]}
                          </Typography>
                        </TableCell>
                      )}
                    </>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Box>
  );
};

export default TableComponent;
